// Open House — the new Post a Project's paid sample steps (minimums.md, Paid
// sample and Last screen): Writer tier → Sample details → Review & post.
//
// The sample is fixed at 1,000 words and has no outline step. Its note (today's
// required requirements) moved to the brief as the sample instructions, and
// its subtitle and requirements file to the brief too. Fields shared with
// today's form are today's field objects (lib/post/services/sample.js), and
// the tier step's heading is today's writing tier step's.

import { sample } from "@/lib/post/services/sample"
import { bookWriting } from "@/lib/post/services/bookWriting"
import {
  REVIEW_STEP, SENSITIVE_ALIASES, TITLE_FIELD, descriptionField, levelRange, money, railWith, tierField,
} from "./bookWritingSteps"
import { WORDING } from "./wording"

// Premium preselected (decision 17).
export const SAMPLE_DEFAULTS = { tier: "Premium" }
export const SAMPLE_ALIASES = SENSITIVE_ALIASES

const todayField = (key) => sample.steps()[0].fields.find((f) => f.key === key || f.type === key)
const sampleTier = () => tierField(todayField("tier"))

// The fixed sample's price at one level (today's estimate: 10 × the rate).
const priceAt = (tier, values, ctx) => sample.estimate({ ...values, tier }, ctx).total

// The open-to-every-level card's price line, per sample.
export function sampleOpenLevelsPrice(values, ctx) {
  const [low, high] = levelRange(sampleTier(), values, ctx).map((tier) => priceAt(tier, values, ctx))
  return low > 0 && high > 0 ? WORDING.openLevelsSamplePrice(money(low), money(high)) : null
}

export function sampleSteps(values = {}, ctx = {}) {
  const writingTier = bookWriting.steps(values, ctx).find((step) => step.id === "tier")

  return [
    {
      id: "tier",
      node: writingTier.node,
      title: writingTier.title,
      sub: writingTier.sub,
      fields: [sampleTier(), { type: "openLevels", key: "open_levels", price: sampleOpenLevelsPrice }],
    },
    {
      id: "details",
      node: WORDING.sampleHeading,
      title: WORDING.sampleHeading,
      fields: [
        todayField("wordcount"),
        todayField("fiction"),
        TITLE_FIELD,
        descriptionField(WORDING.sampleDescriptionHelp, WORDING.sampleDescriptionPlaceholder, WORDING.sampleDescriptionError),
        todayField("genre"),
        todayField("writing_style"),
        todayField("niche"),
      ],
    },
    REVIEW_STEP,
  ]
}

export const sampleRail = (values, ctx) => railWith(sample, values, ctx, levelRange(sampleTier(), values, ctx))
